/** Default cities shown on the home Wallboard. */
export const WALLBOARD_WEATHER_LOCATIONS: string[] = [
  'Salt Lake City, UT'
];
